import React, { useEffect } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import SummaryCard from '../../components/Cards/SummaryCard';
import DonutChart from '../../components/Charts/DonutChart';
import useSupplierDashboard from '../../hooks/dashboard/useSupplierDashboard';

const SuppliersDashboard: React.FC = () => {
  const { stats, fetchStats } = useSupplierDashboard();

  useEffect(() => {
    fetchStats();
  }, []);

  // ✅ Construir dinámicamente los labels y series
  const entityTypeLabels = Object.keys(stats.suppliersByEntityType || {});
  const entityTypeSeries = Object.values(stats.suppliersByEntityType || {});

  const taxpayerLabels = Object.keys(stats.suppliersByTaxpayerCategory || {});
  const taxpayerSeries = Object.values(stats.suppliersByTaxpayerCategory || {});

  const activityLabels = Object.keys(stats.suppliersByEconomicActivity || {});
  const activitySeries = Object.values(stats.suppliersByEconomicActivity || {});

  const districtLabels = Object.keys(stats.suppliersByDistrict || {});
  const districtSeries = Object.values(stats.suppliersByDistrict || {});

  // ✅ Paletas de colores
  const entityTypeColors = ['#3C50E0', '#16A34A', '#F59E0B', '#F97316'];
  const taxpayerColors = ['#10B981', '#6366F1', '#FBBF24', '#F43F5E'];
  const activityColors = ['#8FD0EF', '#0FADCF', '#6366F1', '#F59E0B'];
  const districtColors = ['#14B8A6', '#3C50E0', '#F59E0B', '#EF4444'];

  return (
    <DefaultLayout>
      {/* ✅ Tarjetas resumen */}
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-3 2xl:gap-7.5">
        <SummaryCard
          title="Total de Proveedores"
          value={stats.totalSuppliers.toString()}
          rate=""
          iconName="user-management"
        />
        <SummaryCard
          title="Proveedores Activos"
          value={stats.activeSuppliers.toString()}
          rate=""
          iconName="check-circle"
        />
        <SummaryCard
          title="Proveedores Inactivos"
          value={stats.inactiveSuppliers.toString()}
          rate=""
          iconName="x-circle"
        />
      </div>

      {/* ✅ Gráficos Donut */}
      <div className="mt-6 flex flex-col gap-4 md:flex-row md:gap-6">
        <div className="w-full md:w-1/2">
          <DonutChart
            title="Proveedores por Tipo de Entidad"
            labels={entityTypeLabels}
            series={entityTypeSeries}
            colors={entityTypeColors.slice(0, entityTypeLabels.length)}
          />
        </div>

        <div className="w-full md:w-1/2">
          <DonutChart
            title="Proveedores por Categoría Tributaria"
            labels={taxpayerLabels}
            series={taxpayerSeries}
            colors={taxpayerColors.slice(0, taxpayerLabels.length)}
          />
        </div>
      </div>

      <div className="mt-6 flex flex-col gap-4 md:flex-row md:gap-6">
        <div className="w-full md:w-1/2">
          <DonutChart
            title="Proveedores por Actividad Económica"
            labels={activityLabels}
            series={activitySeries}
            colors={activityColors.slice(0, activityLabels.length)}
          />
        </div>

        <div className="w-full md:w-1/2">
          <DonutChart
            title="Proveedores por Distrito"
            labels={districtLabels}
            series={districtSeries}
            colors={districtColors.slice(0, districtLabels.length)}
          />
        </div>
      </div>
    </DefaultLayout>
  );
};

export default SuppliersDashboard;
